import { TWO_FACTOR, CLEAR_TWO_FACTOR } from "./constants/actionTypes";

const initialState = {
  fetching: false,
  fetched: false,
  onError: false,
  error: {},
  resp: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TWO_FACTOR.pending: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        onError: false,
        error: {}
      };
    }
    case TWO_FACTOR.fulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: {},
        resp: action.payload.data
      };
    }
    case TWO_FACTOR.rejected: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        onError: true,
        error: action.payload
      };
    }
    case CLEAR_TWO_FACTOR.default: {
      return { ...state, fetched: false, onError: false, error: {} };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export default reducer;
